import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [男用户任务页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=145480754
export const homepage = createAsyncThunk(
  'Saada/WeeklyCardGlobalModal/fetch_male_reward_page',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/fetch_male_reward_page',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

export enum SignInEnum {
  未签到 = 0,
  已签到 = 1,
  过期未签到 = 2,
}

interface InitialStateType {
  week_cards: {
    coins: number // 当天签到可获得的金币
    is_sign_in: number // 0未签到 1 已签到 2 过期未签到
    day: number // 第几天
  }[]
  coins: number // 用户金币数
  week_card_status: number // 0: 没买周卡, 1: 买了周卡
  week_card_dollar?: string // 周卡花费数
  week_card_coin_total?: number // 周卡金币数
  week_card_coin_total_dollar?: string // 周卡价值数

  week_card_coin_left?: number // 周卡剩余金币数
  week_card_coin_get?: number // 周卡领取金币数
  week_card_coin_get_dollar?: string // 周卡领取价值数

  week_card_product_id?: string
  week_card_day?: number // 今天是周卡第几天,从1开始
  reward_page_url?: string // 激励页url
}

const initialState: Partial<InitialStateType> = {}

export const WeeklyCardGlobalModalSlice = createSlice({
  name: 'WeeklyCardGlobalModal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(
        state,
        action.payload.data
        //   , {
        //   // 第一天
        //   week_card_day: 1,
        //   week_cards: [
        //     {coins: 100, is_sign_in: 1, day: 1},
        //     {coins: 200, is_sign_in: 0, day: 2},
        //     {coins: 300, is_sign_in: 0, day: 3},
        //     {coins: 400, is_sign_in: 0, day: 4},
        //     {coins: 500, is_sign_in: 0, day: 5},
        //     {coins: 600, is_sign_in: 0, day: 6},
        //     {coins: 700, is_sign_in: 0, day: 7},
        //   ],

        //   // week_card_day: 6,
        //   // week_cards: [
        //   //   {coins: 100, is_sign_in: SignInEnum.已签到, day: 1},
        //   //   {coins: 200, is_sign_in: SignInEnum.已签到, day: 2},
        //   //   {coins: 300, is_sign_in: SignInEnum.已签到, day: 3},
        //   //   {coins: 400, is_sign_in: SignInEnum.已签到, day: 4},
        //   //   {coins: 500, is_sign_in: SignInEnum.过期未签到, day: 5},
        //   //   {coins: 600, is_sign_in: SignInEnum.已签到, day: 6},
        //   //   {coins: 700, is_sign_in: SignInEnum.未签到, day: 7},
        //   // ],

        //   // week_card_day: 7,
        //   // week_cards: [
        //   //   {coins: 100, is_sign_in: SignInEnum.已签到, day: 1},
        //   //   {coins: 200, is_sign_in: SignInEnum.已签到, day: 2},
        //   //   {coins: 300, is_sign_in: SignInEnum.已签到, day: 3},
        //   //   {coins: 400, is_sign_in: SignInEnum.已签到, day: 4},
        //   //   {coins: 500, is_sign_in: SignInEnum.过期未签到, day: 5},
        //   //   {coins: 600, is_sign_in: SignInEnum.已签到, day: 6},
        //   //   {coins: 700, is_sign_in: SignInEnum.已签到, day: 7},
        //   // ],
        //   coins: 500,
        //   week_card_status: 1,
        //   week_card_dollar: '6.99',
        //   week_card_coin_total: 2000,
        //   week_card_coin_total_dollar: '10.00',
        //   week_card_coin_left: 1500,
        //   week_card_coin_get: 500,
        //   week_card_coin_get_dollar: '2.50',
        //   week_card_product_id: 'product_weekcard_001',
        //   reward_page_url: 'https://example.com/reward/1',
        //   popup_button_type: 0,
        // }
      )
    })
  },
})

export default WeeklyCardGlobalModalSlice.reducer
export const WeeklyCardGlobalModalActions = WeeklyCardGlobalModalSlice.actions

export const useWeeklyCardGlobalModalState = () => {
  const data = useSelector((state) => {
    return state.WeeklyCardGlobalModal
  })
  return data
}
